import { render, staticRenderFns } from "./UserMainPopup.vue?vue&type=template&id=e12ca262"
import script from "./UserMainPopup.vue?vue&type=script&lang=js"
export * from "./UserMainPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports